<section class="card-section">
  <app-main-header [name_main]="totalRecords + ' Tareas del proyecto'" [noBackground]="true" [noSticky]="true">
    <!-- <button class="check-btn" mat-flat-button routerLink="/clients/create">
          CREAR
      </button> -->
    <button [matMenuTriggerFor]="menu" class="check-btn" mat-flat-button>Nueva tarea</button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="gotoCreateBasicTask()">
        <span class="material-symbols-outlined">add</span>
        <span>Crear tarea basica</span>
      </button>

      <button mat-menu-item (click)="gotoAnnotations()">
        <span class="material-symbols-outlined">add_box</span>
        <span>Crear tarea con anotación</span>
      </button>
    </mat-menu>
    <!-- <button [disabled]="!selectedTasks.length" class="check-btn"  mat-flat-button color="warn"
      (click)="deleteClient(selectedTasks)">
      BORRAR
  </button> -->
  </app-main-header>
  <div class="search-bar">
    <input class="custom-search" type="text" #searchInput (keyup)="onSearch(searchInput.value)"
      placeholder="Buscar tarea..." />
  </div>

  <div class="cards-container-wrapper">
    <div class="cards-grid">
      <mat-card *ngFor="let task of filteredTasks" [ngClass]="{ 'selected': selectedTasks.includes(task) }"
        (click)="onEditItem(task)" class="task-card">
        <div class="image-container">
          <img *ngIf="task.image_url; else noImage" [src]="task.image_url" class="task-image" />
          <ng-template #noImage>
            <div class="no-image">
              <mat-icon>image_not_supported</mat-icon>
            </div>
          </ng-template>
        </div>

        <mat-card-content>
          <div class="task-header">
            <div class="task-id-container">
              <p class="task-id">Task #{{ task.id }}</p>

              <mat-icon *ngIf="task.state === 'Finished'" matTooltip="El premarcado se implementó correctamente"
                style="color: #4caf50">
                smart_toy
              </mat-icon>

              <mat-icon *ngIf="task.state === 'Failed'"
                matTooltip="El proceso de premarcado falló. Comunícate con el administrador" color="warn">
                smart_toy
              </mat-icon>

              <mat-progress-spinner *ngIf="task.state === 'Process'" mode="indeterminate" diameter="20" color="accent">
              </mat-progress-spinner>
            </div>

            <div class="task-title-container">
              <span class="task-title">{{ task.name }}</span>
              <span class="task-subtitle">{{ task.owner.username }} on {{ task.created_date | date:'MMMM d, y'}}</span>
            </div>
          </div>
        </mat-card-content>
       </mat-card>
       </div>
        <div class="paginator-container">
          <mat-paginator class="paginator" [length]="totalRecords" [pageSize]="pageSize"
            (page)="onPageChange($event)" ></mat-paginator>
        </div>
  </div>
  <!-- Paginador -->
</section>